import React from 'react'

import { MOC_IMPORT_PREVIEW_CARD_OPTIONS } from '@/mocs/import-preview-card';

import CardContent from "@components/card/CardContent";
import PreviewOption from '@/components/preview/PreviewOption'

import './styles/import-item-card.scss'

function ImportItemCard() {
    return (
        <section className="import-item-card">
            <CardContent title="Найденая информация">
                <div className={"import-item-card__content"}>
                    {
                        MOC_IMPORT_PREVIEW_CARD_OPTIONS.map((option) => (
                            <PreviewOption key={option.label} label={option.label} value={option.value} />
                        ))
                    }
                </div>
            </CardContent>
        </section>
    )
}

export default ImportItemCard;